import { FC, useEffect } from 'react';

import { Button, Typography } from 'antd';
import { useNavigate } from 'react-router';

import { showErrorMessage } from '../../helpers/utils/ui';
import { profileApi } from '../../shared/common/api/endpoints/profileApi';
import { endImpersonation } from '../../shared/common/components/header/Header';
import MainLayout from '../../shared/common/components/layouts/MainLayout';
import { routeNames } from '../../shared/common/constants/routes';
import { useTypedSelector } from '../../shared/common/hooks/useTypedSelector';

const { Title } = Typography;
const TelegramConnect: FC = () => {

    const navigate = useNavigate();
    const telegram_connect = useTypedSelector((state) => state.currentUser.telegram_connect);
    const handleClick = () => {

        profileApi
            .getConnectTelegramLink()
            .then((response) => {
                if (response.status === 200) {
                    window.location.href = response.data.telegram_url;
                }
            })
            .catch(() => {
                showErrorMessage(
                    'Ошибка при получении ссылки. Повторите попытку позже.'
                );
            });
    };

    useEffect(() => {
        if (telegram_connect) {

        const link = sessionStorage.getItem('activeLink') ?? routeNames.overview;
            navigate(link);
        }
    }, [ telegram_connect ]);

    return (
        <MainLayout pageTitle="Привязка Telegram">
    <div className="global-loading-container" style={{ display:'flex',flexDirection:'column' }}>
        <Title level={2}>Привяжите Telegram для завершения регистрации</Title>
        <div>
            <Button
                type="primary"
                onClick={handleClick}
            >
                Привязать Telegram
            </Button>
            {localStorage.getItem('access_admin') && <Button style={{ marginLeft:'20px' }} type={'primary'} onClick={()=>endImpersonation()}>Выйти из пользователя</Button>}
        </div>
    </div>
        </MainLayout>
    );
};

export default TelegramConnect;
